define(function(require) {
    const Cell = require('../BaseCell');
    const _ = require('underscore');

    /**
     * A column that not displayed but is included in the export
     * @param {Object} options
     * @returns column definition
     */
    const ExportOnlyCell = function(options) {
        return {
            CellClass: Cell,
            options: _.extend(
                {
                    ExportOnlyCell: true,
                    visible: false,
                    onExport: function(data, type, row, meta, translatedValue, rowModel = undefined) {
                        return translatedValue;
                    }
                },
                options
            )
        };
    };
    return ExportOnlyCell;
});
